import { render, staticRenderFns } from "./RankModal.vue?vue&type=template&id=587a7456"
import script from "./RankModal.vue?vue&type=script&lang=ts"
export * from "./RankModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('587a7456')) {
      api.createRecord('587a7456', component.options)
    } else {
      api.reload('587a7456', component.options)
    }
    module.hot.accept("./RankModal.vue?vue&type=template&id=587a7456", function () {
      api.rerender('587a7456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/customer-rank/RankModal.vue"
export default component.exports